<template>
  <div>
    <div
      v-for="({ nodeId, visible, title, color }, layerIndex) in layers"
      :key="layerIndex"
      class="pt-4 pb-0 focus_bg-transparent"
      :class="{ 'hover_text-gray-600 focus_text-gray-600 hover_bg-transparent': !disabled }"
    >
      <div class="flex dropdown-item-wrapper">
        <VCheckbox
          :id="`${layerIndex}-${title}`"
          class="inline-block w-4 h-4 mt-1 mr-2 text-center align-middle leading-8"
          :color="color"
          :model-value="visible"
          :disabled="disabled"
          @update:model-value="$emit('set-layer-visible', [{ nodeId, visible: !visible }])"
        />
        <label
          class="inline-block m-0 align-middle cursor-pointer select-none"
          :for="`${layerIndex}-${title}`"
          @mouseover="!disabled && $emit('layer-hover', { nodeId, hover: true })"
          @mouseleave="$emit('layer-hover', { nodeId, hover: false })"
        >
          {{ title }}
        </label>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { Layer } from '~/composables/useThreeDLayerGroups'

defineProps({
  layers: {
    type: Array as PropType<Layer[]>,
    required: true,
  },
  disabled: {
    type: [Boolean, String] as PropType<boolean | 'true' | 'false'>,
    default: false,
  },
})

defineEmits(['set-layer-visible', 'layer-hover'])
</script>
